const notEmpty = (data) => 
{
    if(data === "")
    {
        return("This field cannot be empty")
    }
}

export default notEmpty